"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const AppContextProvider_1 = require("../../../contexts/AppContextProvider");
const validateOtp_1 = require("../../../dataLayer/apisWithoutCache/slr/validateOtp");
const constants_1 = require("../../../constants");
const cookiesMember_1 = require("../../../dataLayer/cookiesAndLocalStorage/cookiesMember");
const myProfileLinks_1 = require("../../../helpers/links-builders/myProfileLinks");
const OtpDeepLink = () => {
    const { translations } = (0, styled_components_1.useTheme)();
    const { flowState, dispatch } = (0, AppContextProvider_1.useSsoContext)();
    (0, react_1.useEffect)(() => {
        if (flowState.otpData.linkType === "otpLink") {
            handleOtpLink().then();
        }
        else if (flowState.otpData.linkType === "verifyEmail") {
            handleVerifyEmail().then();
        }
    }, []);
    const handleErrorScreen = (e, cbTranslation, callBack = () => {
    }) => {
        if (e.status === 400) {
            dispatch({
                screenType: constants_1.ScreenConstants.ERROR_SCREEN,
                errorScreen: {
                    title: e.title,
                    description: e.message,
                    cbTranslation,
                    callBack,
                },
            });
        }
    };
    const handleOtpLink = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield (0, validateOtp_1.postOtpVerification)({
                country_code: flowState.country.phone_code,
                otp: flowState.otpData.otp,
                phone_number: flowState.otpData.phoneNumber,
            });
            (0, cookiesMember_1.setTicketCookies)(response.ticket);
            (0, cookiesMember_1.setMemberCookies)(response.member);
            dispatch({
                screenType: constants_1.ScreenConstants.LOGIN_SUCCESS,
                successScreen: {
                    title: response.success.title,
                    description: response.success.description,
                    withAddPost: false,
                },
                memberData: response.member
            });
        }
        catch (e) {
            handleErrorScreen(e, translations.tryAgain);
        }
    });
    const handleVerifyEmail = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield (0, validateOtp_1.postOtpEmailVerification)({
                otp: flowState.otpData.otp,
                email: flowState.otpData.email,
            });
            (0, cookiesMember_1.setMemberCookies)(response);
            if (response === null || response === void 0 ? void 0 : response.ticket) {
                (0, cookiesMember_1.setTicketCookies)(response.ticket);
            }
            dispatch({
                screenType: constants_1.ScreenConstants.LOGIN_SUCCESS,
                successScreen: {
                    title: response.success.title,
                    description: response.success.description,
                    withAddPost: false,
                },
                memberData: response.member
            });
        }
        catch (e) {
            handleErrorScreen(e, translations.tryAgain, () => {
                window.location.href = (0, myProfileLinks_1.getMyEditProfileLink)();
            });
        }
    });
    return null;
};
exports.default = OtpDeepLink;
